/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import axios from 'axios';
import { API } from './Define';

// ponytail: in-flight dedup + recent ok cache; covers duplicate_request without touching exitApp callers
const inflight = new Map();
const recentOk = new Map();
const DEDUP_TTL = 5000;

/* payload ที่มีรูป base64 (filedata/filedatas หลาย MB) ใส่แค่ความยาวในคีย์ — ไม่งั้น recentOk ถือสตริงใหญ่ค้างทั้ง session (Entrio 26 ต.ค. 2569) */
/* ย่อทุกชั้น — refs: [{t:'u', d:<data URL>}] ของหน้าภาพสินค้า AI ซ้อนอยู่ใน object (รีเช็ค 27 ต.ค. 2569) */
const slimValue = (k, v) => (typeof v === 'string' && v.length > 2000 ? `len:${v.length}` : v);
const requestKey = (method, url, token, payload) =>
  `${method}:${url}:${token}:${
    payload instanceof FormData ? 'formdata' : JSON.stringify(payload, slimValue)
  }`;

const resolveFetch = (key, data, resolve) => {
  /* ไม่แคชคำตอบที่เป็นไฟล์ทั้งก้อน (เช่น /image_export/file base64 หลาย MB) — zip ทางสำรองจะกินแรมเปล่า ๆ */
  const big = typeof data?.data === 'string' && data.data.length > 100000;
  if (data?.status === 'ok' && !big) {
    const now = Date.now();
    recentOk.forEach((v, k) => {
      if (now - v.at > DEDUP_TTL) recentOk.delete(k); // ไม่ให้แคชโตไม่มีที่สิ้นสุด
    });
    recentOk.set(key, { data, at: now });
  }
  resolve(data);
};

/* token ล่าสุดที่หน้าเว็บใช้ — ให้ helper ที่ไม่ได้รับ app.token (เช่น imageDownload) เรียก /api ได้ (26 ต.ค. 2569) */
let lastToken = '';
export const currentToken = () => lastToken;

export const FetchData = (mothod, url, token, payload = {}, isFormData = false) => {
  if (token) lastToken = token;
  const key = requestKey(mothod, url, token, payload);
  if (inflight.has(key)) {
    return inflight.get(key);
  }

  const promise = new Promise((resolve, reject) => {
    axios(API + url, {
      headers: {
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
        Authorization: `Bearer ${token}`,
      },
      method: mothod,
      data: payload,
      timeout: 300000,
    })
      .then((res) => {
        const { data } = res;
        if (data?.msg === 'duplicate_request') {
          const cached = recentOk.get(key);
          if (cached && Date.now() - cached.at < DEDUP_TTL) {
            resolve(cached.data);
            return;
          }
        }
        resolveFetch(key, data, resolve);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(() => {
        inflight.delete(key);
      });
  });

  inflight.set(key, promise);
  return promise;
};

export const FetchURL = (mothod, url, token, payload = {}, isFormData = false) => {
  return new Promise((resolve, reject) => {
    axios(url, {
      headers: {
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
        Authorization: `Bearer ${token}`,
      },
      method: mothod,
      data: payload,
      timeout: 300000,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const PostData = (url, payload = {}) => {
  return new Promise((resolve, reject) => {
    axios(API + url, {
      headers: { 'Content-Type': 'application/json' },
      method: 'post',
      data: payload,
      timeout: 300000,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};
